module.exports = "/images/laura.jpg?c6d9c1b0669d966fa24944c5994ee1b6";